import {Spin} from 'com/gongxigames/math/core/game/Spin';
import {FlowFirecatcherState} from '@gongxigames/framework/slot/modules/flow';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import { BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';

export class FlowFreeSpinsFirecatcherState extends FlowFirecatcherState {
    protected setupEvents(): void {
        super.setupEvents();

        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroFinished();
        }
    }

    protected onFreeSpinsOutroFinished(): void {
        if (this.isBigWinAfterFreeGamesFinished()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_FREE_SPINS_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.onBigWinAfterFreeSpinsFinished.bind(this));
        } else {
            this.module.gotoState(FlowModule.BASIC_STATE);
            this.restoreFreeSpinsWinningRoundWinPresentation();
        }

        this.emit(ReelsEvents.ENABLE_SPIN_BY_SPIN_BUTTON);
        this.emit(FlowModuleEvents.CAN_SPIN);
    }

    protected restoreFreeSpinsWinningRoundWinPresentation(): void {
        const spin: Spin = this.module.logic.getSessionForFreeSpinsWinningRound();

        this.emit(FlowModuleEvents.WP_RESTORE, spin);
    }

    protected onFirecatcherOutroFinished(): void {
        if (this.isLastFreeSpin()) {
            this.emit(ReelsEvents.DISABLE_SPIN_BY_SPIN_BUTTON);

            if (this.isBigWinInCurrentRound()) {
                this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
                this.addCallbackToWaitingLIst(BigWinEvents.FINISHED,
                    this.restoreFirecatcherWinningRoundWinPresentation.bind(this));
            } else {
                this.restoreFirecatcherWinningRoundWinPresentation();
            }

            this.addEventToWaitingList(SpinButtonEvents.SPIN_BUTTON_PRESSED, FlowModuleEvents.FREE_SPINS_FINISHED);
            this.addEventToWaitingList(WinPresentationEvents.ALL_PAY_ANIMATIONS_FINISHED, FlowModuleEvents.FREE_SPINS_FINISHED);
            this.addEventToWaitingList(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED,
                FlowModuleEvents.FREE_SPINS_FINISHED);
        } else {
            if (this.isBigWinInCurrentRound()) {
                this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
                this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.restoreWPBeforeFirecatcher.bind(this));
            } else {
                this.restoreWPBeforeFirecatcher();
            }
        }
    }

    protected restoreWPBeforeFirecatcher(): void {
        this.restoreFirecatcherWinningRoundWinPresentation();

        this.addCallbackToWaitingLIst(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onWPRestoreFinished.bind(this));
        this.addCallbackToWaitingLIst(WinPresentationEvents.ALL_PAY_ANIMATIONS_FINISHED,
            this.onWPRestoreFinished.bind(this));
        this.addCallbackToWaitingLIst(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED,
            this.onWPRestoreFinished.bind(this));
    }

    protected onWPRestoreFinished(): void {
        this.emit(FlowModuleEvents.CAN_SPIN);
        this.module.gotoState(FlowModule.FREE_SPINS_STATE);
    }

    protected onBigWinAfterFreeSpinsFinished(): void {
        this.module.gotoState(FlowModule.BASIC_STATE);
        this.restoreFreeSpinsWinningRoundWinPresentation();
    }

    protected isBigWinAfterFreeGamesFinished(): boolean {
        return this.module.logic.isBigTotalWin();
    }

    protected isLastFreeSpin(): boolean {
        return this.module.logic.getFreeGamesCount() === 0;
    }
}
